import dynamic from 'next/dynamic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';
import { getImageSpec } from '@/utils/locals';

const PageConPc = dynamic(() => import('@/components/productRiver/river/indexDynamic'), {
    ssr: true,
});

export default function RiverModule({ cssStyle }: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('riverportablepowerstation');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['au', 'uk', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za']);
    const defaultStyle = {
        background: 'transparent',
        padding: '0',
        margin: '0 auto',
        border: 'none',
        borderRadius: '0',
    };
    const bannerData = [
        {
            bgImgs: [`river-banner_${imgSpec}.webp`, `river-banner_${imgSpec}.jpg`],
            title: t('river.banner_title'),
            des: t('river.banner'),
        },
    ];
    const styles = { ...defaultStyle, ...cssStyle };

    return (
        <div
            className={`${css.animationWrapper} riverModule`}
            style={{
                background: styles.background,
                padding: styles.padding,
                margin: styles.margin,
                border: styles.border,
                borderRadius: styles.borderRadius,
            }}
        >
            <div style={{ width: '100%', marginTop: '-64px' }} className="bannerModule1">
                <BannerModule data={bannerData} config={{ position: 'left', theme: '#000', webpUrl: '/media/river/pc/' }} />
            </div>
            <PageConPc />
        </div>
    );
}
